module.exports = __webpack_public_path__ + "img/02_ic_screws_black_62px.81e63ae2.svg";